import { formatNumber } from '../../utils/format';

export interface DenominatorProps {
  n: number;
  total: number;
  label?: string;
}

/**
 * Compact footer chip: "מבוסס על N מתוך TOTAL <label>".
 */
export function Denominator({ n, total, label = 'מתועדים' }: DenominatorProps) {
  return (
    <span className="honesty-denominator" title={`${n} / ${total}`}>
      מבוסס על {formatNumber(n)} מתוך {formatNumber(total)} {label}
    </span>
  );
}
